export const CUSTOMER_SERVICE_OPENING_HOURS = {
    timeZone: "Europe/Paris",
    startHour: 9,
    endHour: 17,
} as const
